import React from 'react';

const ReviewIcon = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path 
                d="M10.1777
                12.9511C13.2017
                12.9511
                15.6532
                10.4996
                15.6532
                7.47555C15.6532
                4.45148
                13.2017
                2
                10.1777
                2C7.15363
                2
                4.70215
                4.45148
                4.70215
                7.47555C4.70215
                10.4996
                7.15363
                12.9511
                10.1777
                12.9511Z" 
                stroke="#595959"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            <path
                d="M17.9998
                15.2978L14.0176
                11.3867"
                stroke="#595959"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            <path
                d="M3.42222
                4.13348C2.64
                4.13348
                2
                4.77348
                2
                5.5557V16.5779C2
                17.3601
                2.64
                18.0001
                3.42222
                18.0001H10.5333C11.3155
                18.0001
                11.9555
                17.3601
                11.9555
                16.5779V14.8001"
                stroke="#595959" 
                strokeMiterlimit="10" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
            <path
                d="M8.75586
                4.13348H10.5336C11.3159
                4.13348
                11.9559
                4.77348
                11.9559
                5.5557V10.1779"
                stroke="#595959"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"/>

            <path
                d="M6.83545
                8.40015H9.32431"
                stroke="#595959"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />


            <path
                d="M7.19092
                6.2666H9.32423"
                stroke="#595959"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            <path
                d="M8.61328
                10.5332H9.32439"
                stroke="#595959"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default ReviewIcon;